<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconGroup_24"
>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.75 3.716a4.354 4.354 0 0 1 4.35 4.348 4.354 4.354 0 0 1-4.35 4.35 4.355 4.355 0 0 1-4.35-4.35 4.354 4.354 0 0 1 4.35-4.348ZM9.156 9.34A3.16 3.16 0 0 1 6 12.496 3.16 3.16 0 0 1 2.844 9.34 3.16 3.16 0 0 1 6 6.185 3.159 3.159 0 0 1 9.156 9.34ZM6 13.845c1.266 0 2.265.139 3.07.368-.61.348-1.164.741-1.604 1.221-.33.358-.982 1.082-1.3 2.566H.912a.862.862 0 0 1-.852-.987c.15-.959.508-1.347.729-1.588l.021-.023c.818-.892 2.372-1.557 5.19-1.557ZM8.738 20h14.024c.721 0 1.284-.648 1.171-1.361-.209-1.339-.714-1.88-1.042-2.23l-.02-.021c-1.134-1.214-3.273-2.115-7.122-2.115-3.882 0-6.024.917-7.15 2.146l-.029.03c-.305.332-.798.867-1.005 2.19A1.187 1.187 0 0 0 8.738 20Z"
        fill="currentColor"
    />
</svg>
